<template>
  <MDBRow>
    <MDBCol col="12" md="6" xl="4" v-for="(data, i) in supportData" :key="i" :class="`${data.show ? '' : 'd-none'}`">
      <Card class="mb-4" :data="data" :linkText="data.linkText" minHeight="container-height" v-if="data.show" />
    </MDBCol>
  </MDBRow>
</template>

<script setup>
import { MDBRow, MDBCol } from "mdb-vue-ui-kit";
import Card from "@/components/General/Card/index.vue";
import TokenService from "@/services/storage.service";
import { useI18n } from "vue-i18n";
import { useTenantConfig } from "@/composables/useTenantConfig";

const { tenantConfig } = useTenantConfig();
const { t } = useI18n()

const supportData = [
  {
    name: t("salesPromotions.salesPromotions.title"),
    link: { name: "salesPromotions" },
    description: t("salesPromotions.salesPromotions.desc"),
    image: require("@/assets/img/sales_promotions_2026.jpg"),
    linkText: t("global.buttons.discover"),
    show: true,
  },
  {
    name: t("salesPromotions.displaysFurniture.title"),
    link: { name: "shop" },
    description: t("salesPromotions.displaysFurniture.desc"),
    image: require("@/assets/img/disaply_furniture.png"),
    linkText: t("global.buttons.showAllProducts"),
    show: TokenService.showElement("displaysFurniture.see"),
  },
  {
    name: t("salesPromotions.individualSupport.title"),
    link: { name: "shop" },
    description: t("salesPromotions.individualSupport.desc"),
    image: require("@/assets/img/individual_support.jpg"),
    linkText: t("global.buttons.showAllProducts"),
    show: TokenService.showElement("individualSupport.see"),
  },
  {
    name: t("onlineVisibility.box.title"),
    link: { name: "onlineVisibility" },
    description: t("onlineVisibility.description"),
    image: require("@/assets/img/uberall-logo.jpg"),
    linkText: t("global.buttons.discover"),
    show: TokenService.showElement("uberall.see"),
  },

  {
    name: t("priceList.productInfo.index.categories.calculator.title"),
    link: { name: "fuelCalculator" },
    description: t(
      "priceList.productInfo.index.categories.calculator.description"
    ),
    image: require("@/assets/img/fuelCalc.png"),
    show: tenantConfig.value.showFuelCalculator,
    linkText: t("global.buttons.discover"),
    simpleLink: false,
  },
];
</script>
